// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

function ProductH(props) {
  const to = `/products/${props.id}`;
  let percentOff;
  let offPrice: any = `${props.price}$`;

  if (props.percentOff && props.percentOff > 0) {
    percentOff = (
      <div
        className="badge bg-dim py-2 text-white position-absolute"
        style={{ top: '0.5rem', left: '0.5rem' }}
      >
        {props.percentOff}% OFF
      </div>
    );

    offPrice = (
      <>
        <del>{props.price}$</del> {props.price - (props.percentOff * props.price) / 100}$
      </>
    );
  }
  return (
    <div className="col">
      <div className="card shadow-sm">
        <div className="row g-0">
          <div className="col-4">
            <Link to={to}>
              {percentOff}
              <img className="rounded-start bg-dark cover w-100 h-100" alt="" src={props.image} />
            </Link>
          </div>
          <div className="col-8">
            <div className="card-body h-100">
              <div className="d-flex flex-column h-100">
                <h5 className="card-title text-dark text-truncate mb-1">{props.name}</h5>
                <span className="card-text text-muted mb-2 flex-shrink-0">{offPrice}</span>
                <div className="mt-auto d-flex">
                  <Link to={to} className="btn btn-outline-dark ms-auto">
                    Detail
                  </Link>
                  {/* <button className="btn btn-outline-dark ms-auto">
                    <FontAwesomeIcon icon={['fas', 'cart-plus']} /> Add to cart
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductH;
